import { render, staticRenderFns } from "./54modelAlpha.vue?vue&type=template&id=f0e4df0a&scoped=true&"
import script from "./54modelAlpha.vue?vue&type=script&lang=js&"
export * from "./54modelAlpha.vue?vue&type=script&lang=js&"
import style0 from "./54modelAlpha.vue?vue&type=style&index=0&id=f0e4df0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e4df0a",
  null
  
)

export default component.exports